import React, { PropsWithChildren } from "react";
import cx from "classnames";
import { leftHandNavId, transitionBaseClass } from "../../constants";

interface Props {
  visible: boolean;
}

const LeftHandNav = ({ visible, children }: PropsWithChildren<Props>) => {
  const placeholderClass = cx("w-0 relative", transitionBaseClass, {
    "lg:w-[320px]": visible,
  });

  const navBarClass = cx(
    "w-full md:w-[320px] fixed h-screen pb-[60px] bg-white border-r",
    "border-grey-light-2 z-[4] overflow-y-auto",
    transitionBaseClass,
    {
      "translate-x-0": visible,
      "-translate-x-full points": !visible,
    }
  );

  return (
    <div id={leftHandNavId} className={placeholderClass}>
      <div className={navBarClass}>{children}</div>
    </div>
  );
};

export default LeftHandNav;
